import { format, formatDistanceToNow, isToday, isYesterday, parseISO } from 'date-fns';
import { ru } from 'date-fns/locale';
import type { Message } from './types';

export function formatMessageTime(timestamp: string): string {
    const date = parseISO(timestamp);

    if (isToday(date)) {
        return format(date, 'HH:mm', { locale: ru });
    }

    if (isYesterday(date)) {
        return `вчера, ${format(date, 'HH:mm', { locale: ru })}`;
    }

    return format(date, 'd MMM, HH:mm', { locale: ru });
}

export function formatMessageTimeAgo(timestamp: string): string {
    const date = parseISO(timestamp);
    return formatDistanceToNow(date, { addSuffix: true, locale: ru });
}

export function formatMessageDateGroup(timestamp: string): string {
    const date = parseISO(timestamp);
    
    if (isToday(date)) return 'Сегодня';
    if (isYesterday(date)) return 'Вчера';
    
    return format(date, 'd MMMM yyyy', { locale: ru });
}

export function groupMessagesByDate(messages: Message[]): Map<string, Message[]> {
    const groups = new Map<string, Message[]>();
    
    messages.forEach(msg => {
        const key = formatMessageDateGroup(msg.timestamp);
        const existing = groups.get(key) || [];
        groups.set(key, [...existing, msg]);
    });
    
    return groups;
}

export function sortMessagesByDate(messages: Message[]): Message[] {
    return [...messages].sort((a, b) => 
        new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
    );
}